// frontend/src/site/theme/presets.js
// Presets oficiais do Microsite (Elion)
// Fonte única da verdade visual
// Estilos (Quadrante 01):
// - Humano
// - Autoridade
// - Premium
// - Imobiliária
// Paletas: A | B | C
// OBS: Densidade, botão e card são definidos pelo ESTILO (não pelo usuário)

export const SITE_PRESETS = {
  /* =====================================================
   * HUMANO — próximo, consultivo, acessível
   * ===================================================== */

  humano_a: {
    id: 'humano_a',
    label: 'Humano — Azul Claro',
    description: 'Próximo, simples e acessível',
    styleId: 'humano',
    paletteId: 'a',
    mode: 'light',

    bg: '#FFFFFF',
    card: '#F8FAFC',
    text: '#0F172A',
    muted: '#64748B',
    border: '#E2E8F0',
    accent: '#2563EB',
    accentText: '#FFFFFF',

    fontHeading:
      '"Inter", system-ui, -apple-system, "Segoe UI", Roboto, sans-serif',
    fontBody:
      '"Inter", system-ui, -apple-system, "Segoe UI", Roboto, sans-serif',
    headingWeight: 600,
    bodyWeight: 400,
    letterSpacingHeading: '-0.02em',
    lineHeightHeading: 1.2,

    radius: 14,

    // 🔒 comportamento do estilo
    layoutDensity: 'normal',
    buttonStyle: 'soft',
    cardStyle: 'soft',
    iconStyle: 'stroke',
  },

  humano_b: {
    id: 'humano_b',
    label: 'Humano — Verde Suave',
    description: 'Consultivo, acolhedor e leve',
    styleId: 'humano',
    paletteId: 'b',
    mode: 'light',

    bg: '#F7FDF9',
    card: '#FFFFFF',
    text: '#064E3B',
    muted: '#6B7280',
    border: '#D1FAE5',
    accent: '#10B981',
    accentText: '#022C22',

    fontHeading:
      '"Inter", system-ui, -apple-system, "Segoe UI", Roboto, sans-serif',
    fontBody:
      '"Inter", system-ui, -apple-system, "Segoe UI", Roboto, sans-serif',
    headingWeight: 600,
    bodyWeight: 400,
    letterSpacingHeading: '-0.02em',
    lineHeightHeading: 1.2,

    radius: 14,
    layoutDensity: 'normal',
    buttonStyle: 'soft',
    cardStyle: 'soft',
    iconStyle: 'stroke',
  },

  humano_c: {
    id: 'humano_c',
    label: 'Humano — Neutro Moderno',
    description: 'Amigável, urbano e contemporâneo',
    styleId: 'humano',
    paletteId: 'c',
    mode: 'light',

    bg: '#FAFAFA',
    card: '#FFFFFF',
    text: '#1F2937',
    muted: '#6B7280',
    border: '#E5E7EB',
    accent: '#6366F1',
    accentText: '#FFFFFF',

    fontHeading:
      '"Inter", system-ui, -apple-system, "Segoe UI", Roboto, sans-serif',
    fontBody:
      '"Inter", system-ui, -apple-system, "Segoe UI", Roboto, sans-serif',
    headingWeight: 600,
    bodyWeight: 400,
    letterSpacingHeading: '-0.02em',
    lineHeightHeading: 1.2,

    radius: 14,
    layoutDensity: 'normal',
    buttonStyle: 'soft',
    cardStyle: 'soft',
    iconStyle: 'stroke',
  },

  /* =====================================================
   * AUTORIDADE — sério, institucional, confiável
   * ===================================================== */

  autoridade_a: {
    id: 'autoridade_a',
    label: 'Autoridade — Azul Institucional',
    description: 'Institucional, sólido e confiável',
    styleId: 'autoridade',
    paletteId: 'a',
    mode: 'light',

    bg: '#F9FAFB',
    card: '#FFFFFF',
    text: '#0F172A',
    muted: '#64748B',
    border: '#E2E8F0',
    accent: '#1D4ED8',
    accentText: '#FFFFFF',

    fontHeading: '"Merriweather", Georgia, serif',
    fontBody:
      '"Source Sans 3", system-ui, -apple-system, "Segoe UI", Roboto, sans-serif',
    headingWeight: 700,
    bodyWeight: 400,
    letterSpacingHeading: '0em',
    lineHeightHeading: 1.3,

    radius: 12,
    layoutDensity: 'normal',
    buttonStyle: 'solid',
    cardStyle: 'flat',
    iconStyle: 'stroke',
  },

  autoridade_b: {
    id: 'autoridade_b',
    label: 'Autoridade — Grafite',
    description: 'Corporativo moderno e elegante',
    styleId: 'autoridade',
    paletteId: 'b',
    mode: 'light',

    bg: '#F8FAFC',
    card: '#FFFFFF',
    text: '#111827',
    muted: '#6B7280',
    border: '#D1D5DB',
    accent: '#334155',
    accentText: '#FFFFFF',

    fontHeading: '"Merriweather", Georgia, serif',
    fontBody:
      '"Source Sans 3", system-ui, -apple-system, "Segoe UI", Roboto, sans-serif',
    headingWeight: 700,
    bodyWeight: 400,
    letterSpacingHeading: '0em',
    lineHeightHeading: 1.3,

    radius: 12,
    layoutDensity: 'normal',
    buttonStyle: 'solid',
    cardStyle: 'flat',
    iconStyle: 'stroke',
  },

  autoridade_c: {
    id: 'autoridade_c',
    label: 'Autoridade — Verde Profissional',
    description: 'Autoridade com leve toque moderno',
    styleId: 'autoridade',
    paletteId: 'c',
    mode: 'light',

    bg: '#F9FAFB',
    card: '#FFFFFF',
    text: '#0F172A',
    muted: '#64748B',
    border: '#E5E7EB',
    accent: '#047857',
    accentText: '#ECFDF5',

    fontHeading: '"Merriweather", Georgia, serif',
    fontBody:
      '"Source Sans 3", system-ui, -apple-system, "Segoe UI", Roboto, sans-serif',
    headingWeight: 700,
    bodyWeight: 400,
    letterSpacingHeading: '0em',
    lineHeightHeading: 1.3,

    radius: 12,
    layoutDensity: 'normal',
    buttonStyle: 'solid',
    cardStyle: 'flat',
    iconStyle: 'stroke',
  },

  /* =====================================================
   * PREMIUM — alto padrão, sofisticação, exclusividade
   * ===================================================== */

  premium_a: {
    id: 'premium_a',
    label: 'Premium — Ouro Clássico',
    description: 'Luxo clássico e exclusivo',
    styleId: 'premium',
    paletteId: 'a',
    mode: 'dark',

    bg: '#0B0F14',
    card: '#121821',
    text: '#F8FAFC',
    muted: '#94A3B8',
    border: '#1E293B',
    accent: '#D4AF37',
    accentText: '#0B0F14',

    fontHeading: '"Cormorant Garamond", "Times New Roman", serif',
    fontBody:
      '"Inter", system-ui, -apple-system, "Segoe UI", Roboto, sans-serif',
    headingWeight: 600,
    bodyWeight: 400,
    letterSpacingHeading: '0.02em',
    lineHeightHeading: 1.3,

    radius: 22,
    layoutDensity: 'airy',
    buttonStyle: 'outline',
    cardStyle: 'elevated',
    iconStyle: 'filled',
  },

  premium_b: {
    id: 'premium_b',
    label: 'Premium — Bege Sofisticado',
    description: 'Elegante, imobiliário de alto padrão',
    styleId: 'premium',
    paletteId: 'b',
    mode: 'light',

    bg: '#FAF7F2',
    card: '#FFFFFF',
    text: '#1F2933',
    muted: '#6B7280',
    border: '#E5DED5',
    accent: '#C0843D',
    accentText: '#FFFFFF',

    fontHeading: '"Playfair Display", Georgia, serif',
    fontBody:
      '"Inter", system-ui, -apple-system, "Segoe UI", Roboto, sans-serif',
    headingWeight: 600,
    bodyWeight: 400,
    letterSpacingHeading: '-0.01em',
    lineHeightHeading: 1.25,

    radius: 22,
    layoutDensity: 'airy',
    buttonStyle: 'outline',
    cardStyle: 'elevated',
    iconStyle: 'stroke',
  },

  premium_c: {
    id: 'premium_c',
    label: 'Premium — Preto Contemporâneo',
    description: 'Luxo urbano e moderno',
    styleId: 'premium',
    paletteId: 'c',
    mode: 'dark',

    bg: '#0F172A',
    card: '#111827',
    text: '#E5E7EB',
    muted: '#9CA3AF',
    border: '#1F2937',
    accent: '#10B981',
    accentText: '#022C22',

    fontHeading:
      '"Poppins", system-ui, -apple-system, "Segoe UI", Roboto, sans-serif',
    fontBody:
      '"Inter", system-ui, -apple-system, "Segoe UI", Roboto, sans-serif',
    headingWeight: 700,
    bodyWeight: 400,
    letterSpacingHeading: '-0.01em',
    lineHeightHeading: 1.15,

    radius: 22,
    layoutDensity: 'airy',
    buttonStyle: 'outline',
    cardStyle: 'elevated',
    iconStyle: 'filled',
  },

  /* =====================================================
   * IMOBILIÁRIA — catálogo, volume, eficiência
   * ===================================================== */

  imobiliaria_a: {
    id: 'imobiliaria_a',
    label: 'Imobiliária — Azul Catálogo',
    description: 'Layout objetivo para grandes estoques',
    styleId: 'imobiliaria',
    paletteId: 'a',
    mode: 'light',

    bg: '#F8FAFC',
    card: '#FFFFFF',
    text: '#0F172A',
    muted: '#64748B',
    border: '#E2E8F0',
    accent: '#2563EB',
    accentText: '#FFFFFF',

    fontHeading: '"Inter", system-ui, sans-serif',
    fontBody: '"Inter", system-ui, sans-serif',
    headingWeight: 600,
    bodyWeight: 400,
    letterSpacingHeading: '-0.02em',
    lineHeightHeading: 1.2,

    radius: 10,
    layoutDensity: 'compact',
    buttonStyle: 'solid',
    cardStyle: 'flat',
    iconStyle: 'stroke',
  },

  imobiliaria_b: {
    id: 'imobiliaria_b',
    label: 'Imobiliária — Grafite',
    description: 'Imobiliária moderna e profissional',
    styleId: 'imobiliaria',
    paletteId: 'b',
    mode: 'light',

    bg: '#F9FAFB',
    card: '#FFFFFF',
    text: '#111827',
    muted: '#6B7280',
    border: '#D1D5DB',
    accent: '#334155',
    accentText: '#FFFFFF',

    fontHeading: '"Inter", system-ui, sans-serif',
    fontBody: '"Inter", system-ui, sans-serif',
    headingWeight: 600,
    bodyWeight: 400,
    letterSpacingHeading: '-0.02em',
    lineHeightHeading: 1.2,

    radius: 10,
    layoutDensity: 'compact',
    buttonStyle: 'solid',
    cardStyle: 'flat',
    iconStyle: 'stroke',
  },

  imobiliaria_c: {
    id: 'imobiliaria_c',
    label: 'Imobiliária — Verde Institucional',
    description: 'Catálogo imobiliário institucional',
    styleId: 'imobiliaria',
    paletteId: 'c',
    mode: 'light',

    bg: '#F8FAFC',
    card: '#FFFFFF',
    text: '#064E3B',
    muted: '#6B7280',
    border: '#D1FAE5',
    accent: '#047857',
    accentText: '#ECFDF5',

    fontHeading: '"Inter", system-ui, sans-serif',
    fontBody: '"Inter", system-ui, sans-serif',
    headingWeight: 600,
    bodyWeight: 400,
    letterSpacingHeading: '-0.02em',
    lineHeightHeading: 1.2,

    radius: 10,
    layoutDensity: 'compact',
    buttonStyle: 'solid',
    cardStyle: 'flat',
    iconStyle: 'stroke',
  },
};
